import { GetSuggestTimeInfo, IGetSuggestTimeRequest } from "../services/entities/suggestTimeEntity";
import { getSuggestTime } from "../services/useGetSuggestTime";

export const useFindAvailableTime = () => {
  const onGetSuggestTime = async (payload: IGetSuggestTimeRequest): Promise<GetSuggestTimeInfo[]> => {
    const response = await getSuggestTime(payload);
    return response.data?.suggestedSlots || [];
  };

  return {
    onGetSuggestTime,
  };
};
